'use strict';
const moment = require('moment');

module.exports = ['$scope', 'UrlWatcherService', 'ForecastSvc', '$timeout', 'OrderPlannerSvc', function ($scope, UrlWatcherService, ForecastSvc, $timeout, OrderPlannerSvc) {
    let PivotTable = this;

    function isNumber(value) {
        if ((undefined === value) || (null === value)) {
            return false;
        }
        if (typeof value === 'number') {
            return true;
        }
        if (typeof  value === 'boolean') {
            return false;
        }
        return !isNaN(value - 0);
    }


    function mapOrderPlansAsSources() {

        OrderPlannerSvc.list($scope.reportOptions.plant).then(function (result) {

            let sources = angular.copy(PivotTable.defaultSources);

            result.data.forEach(function (item) {
                sources.push({
                    id: item.id,
                    name: `${item.description} - ${item.year}`,
                    year: item.year,
                    type: "order_plan"
                });
            });

            PivotTable.sources = sources;
            PivotTable.source = PivotTable.sources[0];
        });
    }

    // ------------------
    // Scope functions
    // ------------------
    class PivotData {
        constructor() {
            this.table = [];
            this.index = [];
            this.index_labels = [];
            this.columns = [];
        }

        setData(response) {
            let row, previous_row;

            // Break for empty objects
            if (!response || response.null) {
                return;
            }

            this.index = response.table.index.map((row) => {

                // Make sure it's an array
                if (!Array.isArray(row)) {
                    row = [row];
                }

                return row.map((item) => {
                    return {value: item};
                });
            });

            function rowsMatch(row1, row2, index) {
                for (let i = index; i >= 0; i--) {
                    if (row1[i].value !== row2[i].value){
                        return false;
                    }
                }
                return true;
            }

            // Iterate over items to find the root items
            if (this.index.length > 2) {
                for (var i = this.index.length - 2; i >= 0; i--) {
                    row = this.index[i];
                    previous_row = this.index[i + 1];

                    for (var j = row.length - 1; j >= 0; j--) {
                        if (rowsMatch(row, previous_row, j)) {
                            row[j].rowspan = (previous_row[j].rowspan || 1) + 1;
                            previous_row.splice(j, 1);
                        }
                    }
                }
            }

            this.index_labels = response.table.index_labels.map((value) => {
                return {value: value};
            });

            this.table = response.table.data.map((row) => {
                return row.map((data) => {
                    return {value: data};
                });
            });
            this.columns = response.table.columns;
        }
    }

    PivotTable.formatCell = function (value) {
        if (isNumber(value)) {
            return Math.round(value);
        } else if (typeof value === 'boolean') {
            return value ? "Yes" : "No";
        } else {
            return value;
        }
    };

    PivotTable.updateAvailableFields = function () {
        let available_fields = PivotTable.fields.filter(function (item) {
            return PivotTable.fields_selected.indexOf(item) === -1;
        });
        PivotTable.fields_available.length = 0;
        Array.prototype.splice.apply(PivotTable.fields_available, [0, 0].concat(available_fields));
    };

    // ------------------
    // Load Dependent Data
    // ------------------
    PivotTable.refreshData = function () {
        let plant = $scope.reportOptions.plant;

        let selected_fields = encodeURIComponent(PivotTable.fields_selected.join(','));

        let suffix = "&fields=" + selected_fields;

        suffix += "&source=" + $scope.reportOptions.type.split('.')[0];

        if (PivotTable.source.type === "order_plan") {
            suffix += "&order_plan=" + PivotTable.source.id;
        }

        ForecastSvc.get(plant,
            "pandas2",
            $scope.reportOptions.from,
            $scope.reportOptions.to,
            $scope.reportOptions.resolution,
            suffix)

            .then(function (result) {
                PivotTable.data = new PivotData();
                PivotTable.data.setData(result.data);

                PivotTable.fields = result.data.available_fields;
                PivotTable.updateAvailableFields();
            }, function (a) {
                console.error('error', a);
            });

        PivotTable.excel_path = ForecastSvc.getUrl(plant,
            "pandas2",
            $scope.reportOptions.from,
            $scope.reportOptions.to,
            $scope.reportOptions.resolution,
            suffix, "xlsx");
    };
    $scope.refreshData = () => {
        PivotTable.refreshData();
    };

    // ------------------
    // Watches
    // ------------------
    function initWatches() {

        PivotTable.urlWatcher = new UrlWatcherService(
            $scope,
            $scope.reportOptions,
            ['from', 'to', 'resolution', 'group_by', "source"],
            {
                plant: $scope.plants[0].id.toString(),
                source: PivotTable.sources[0].type,
                resolution: 'day',
                from: moment().day(0).startOf('day').format($scope.$root.dateFormat.moment_url),
                to: moment().day(5).startOf('day').format($scope.$root.dateFormat.moment_url),
                group_by: "material"
            });

        PivotTable.urlWatcher.optionsChanged = function (changes) {
            console.log(changes);

            if (changes.plant) {
                mapOrderPlansAsSources();
                if (changes.plant.oldVal) {
                    PivotTable.urlWatcher.resetOptionToDefault("source");
                }
            }

            // get date values from url
            PivotTable.form.fromInput = moment(this.options.from, $scope.$root.dateFormat.moment_url).format($scope.$root.dateFormat.moment);
            PivotTable.form.toInput = moment(this.options.to, $scope.$root.dateFormat.moment_url).format($scope.$root.dateFormat.moment);

            // get group_by from url
            let group_by = this.options.group_by.split(',');

            PivotTable.fields_selected.length = 0;
            Array.prototype.splice.apply(PivotTable.fields_selected, [0, 0].concat(group_by));

            // filter out the selected values
            PivotTable.updateAvailableFields();

            // get the source
            let order_plan_regex = /^order_plan_(\d+)$/;

            if (!this.options.source) {
                PivotTable.source = PivotTable.sources[0];
            } else {
                if (this.options.source === "calendar_data") {
                    PivotTable.source = PivotTable.sources[0];
                }
                else if (order_plan_regex.test(this.options.source)) {
                    var parts = order_plan_regex.exec(this.options.source);
                    var id = parseInt(parts[1]);
                    PivotTable.source = Array.findObject(PivotTable.sources, "id", id);
                }
            }

            $scope.refreshData();
        };

        PivotTable.urlWatcher.locationUpdated = function () {
        };
    }

    $scope.$watch(function () {
        return PivotTable.source;
    }, function (newVal) {

        if (!newVal) {return;}

        let source_key = newVal.type;

        if (newVal.type === "order_plan") {
            source_key = `${newVal.type}_${newVal.id}`;
            let date = moment({year: newVal.year});
            $scope.reportOptions.from = date.startOf("year").format($scope.$root.dateFormat.moment_url);
            $scope.reportOptions.to = date.endOf("year").format($scope.$root.dateFormat.moment_url);
            $scope.reportOptions.resolution = "month";
        }

        $scope.reportOptions.source = source_key;
    });

    // ------------------
    // Initialization
    // ------------------
    PivotTable.fields = ['material', 'nightshift', 'created_by', 'customer', 'tentative', 'plant', 'supplier'].sort();

    PivotTable.fields_available = ['nightshift', 'created_by', 'customer', 'tentative', 'plant', 'supplier'];
    PivotTable.fields_selected = ["material"];

    PivotTable.defaultSources = [{
        name: "Calendar Data",
        type: "calendar_data"
    }];

    PivotTable.sources = angular.copy(PivotTable.defaultSources);

    PivotTable.form = {};

    initWatches();

    // add a timeout to fake $locationChangeSuccess
    $timeout(function () {
        PivotTable.urlWatcher.extractReportOptionsFromLocation();
    });
}];
